module.exports = __webpack_public_path__ + "static/media/github.6131b7ab.png";